import { Tab, Tabs, alpha, useMediaQuery, useTheme } from "@mui/material";
import { ReactElement } from "react";
import { NavegacaoPaper } from "../../styles";

export interface SecaoNavegacao<T extends string = string> {
    id: T;
    titulo: string;
    icone: ReactElement;
}

interface NavegacaoSecoesProps<T extends string> {
    secoes: SecaoNavegacao<T>[];
    secaoAtiva: T;
    onChange: (secao: T) => void;
}

/**
 * Navegação das seções de configuração: lista vertical fixa no desktop
 * e abas roláveis em telas menores.
 */
export const NavegacaoSecoes = <T extends string>({ secoes, secaoAtiva, onChange }: NavegacaoSecoesProps<T>) => {
    const theme = useTheme();
    const horizontal = useMediaQuery("(max-width: 1080px)");

    return (
        <NavegacaoPaper elevation={0}>
            <Tabs
                orientation={horizontal ? "horizontal" : "vertical"}
                variant={horizontal ? "scrollable" : "standard"}
                scrollButtons={horizontal ? "auto" : false}
                allowScrollButtonsMobile={horizontal}
                value={secaoAtiva}
                onChange={(_, secao) => onChange(secao as T)}
                sx={{
                    "& .MuiTabs-indicator": { display: "none" },
                    "& .MuiTabs-flexContainer": { gap: "0.25rem" },
                    "& .MuiTab-root": {
                        minHeight: 46,
                        borderRadius: "10px",
                        textTransform: "none",
                        fontWeight: 500,
                        fontSize: "0.875rem",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        color: theme.palette.text.secondary,
                        "&.Mui-selected": {
                            color: theme.palette.primary.main,
                            backgroundColor: alpha(theme.palette.primary.main, 0.1),
                            fontWeight: 600
                        }
                    }
                }}
            >
                {secoes.map(secao => (
                    <Tab
                        key={secao.id}
                        value={secao.id}
                        label={secao.titulo}
                        icon={secao.icone}
                        iconPosition="start"
                    />
                ))}
            </Tabs>
        </NavegacaoPaper>
    );
}
